window.global = {
    momentFormat: 'YYYY-MM-DD',
    displayFormat: 'YYYY/MM/DD',
    displayDateTimeFormat: 'YYYY/MM/DD HH:mm',
    displayTimeFormat: 'HH:mm',
    officeHours: 'OFFICE HOURS',
    shiftDuty: 'SHIFT DUTY',
    am: 'AM',
    pm: 'PM',
    sectionOne: 'Section One',
    sectionTwo: 'Section Two',
    homeMode: 'Home Mode',
    submitMode: 'Submit Mode',
    formMode: 'Form Mode',
    editMode: 'Edit Mode',
    viewMode: 'View Mode',
    approveMode: 'Approve Mode',
    singleApprove: 'Single Approve',
    multipleApprove: 'Multiple Approve',
    myTeamApprove: 'My Team Approve',
    compLeaveRequest: 'Comp Leave Request',
    LeaveApplication: 'Leave Application',
    CashOut: 'Cash Out',
    hrAdmin: 'HR Admin',
    normalApprover: 'Normal Approver',
    pending: String(1),
    approved: String(2),
    rejected: String(3),
    submitted: String(4),
    withdrawn: String(5),
    cancelled: String(6),
    amChinese: '上午',
    pmChinese: '下午',
    sectionOneChinese: '第一節',
    sectionTwoChinese: '第二節',
    patterns: [
        'AM',
        'PM',
        'Section One',
        'Section Two',
        '上午',
        '下午',
        '第一節',
        '第二節'
    ],
    fmDepartment: 'Facility Management',
}

export default window.global;
